export default __webpack_public_path__ + "static/media/none.b1badaa1.png";